import { useContext, useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import AuthContext from "../../../Auth/AuthContext";
import { ToastContainer, toast } from "react-toastify";
import { Images } from "./constants/images";
import routes from "../../routes/route";
import { verifyToken } from "../../../API/authAPI";
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import useSocket from "../../../hooks/useSocket";

window.Pusher = Pusher;

const TurboSportsHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { profile, setProfile, logout, portalSettings } = useContext(AuthContext);
  const [showMenu, setShowMenu] = useState(false);

  const handleMenuClose = () => {
    setShowMenu(false);
  };

  const handleNavigate = (path) => {
    navigate(path);
    handleMenuClose();
  };

  const handleLogout = async () => {
    await logout(navigate);
    handleMenuClose();
  };

  const handleTurboSportsClick = () => {
    sessionStorage.setItem("launchTurboSports", "true");
    handleNavigate(routes.pages.sportsbook.turboSports);
  };

  // --- WebSocket Connection for Real-Time Balance ---
  useSocket(profile, setProfile);

  const handleDepositClick = async () => {
    try {
      const res = await verifyToken();

      if (res?.type === "valid" && portalSettings?.auto_deposit === 1) {
        navigate(routes.transactions.paymentMethod);
      } else if (res?.type === "valid" && portalSettings?.auto_deposit !== 1) {
        toast.error(
          "Deposits are temporarily unavailable. Please reach out to the support team.",
          { position: "top-right", autoClose: 3000 }
        );
      } else {
        toast.error("Session expired. Redirecting to login...", {
          position: "top-right",
          autoClose: 3000,
        });
        localStorage.removeItem("token");
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      }
    } catch (err) {
      toast.error("Please login again.", {
        position: "top-right",
        autoClose: 3000,
      });
      localStorage.removeItem("token");
      setTimeout(() => {
        navigate("/login");
      }, 3000);
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={5000} theme="dark" />
      <header className="bgbody-color page-header container-fluid p-0">
        <nav className=" navbar p-2" style={{ background: "#000", borderBottom: "1px solid #333" }}>
          <div className="container p-0">
            <div className="d-flex justify-content-between w-100 align-items-center">
              {/* Logo + Menu Button */}
              <div className="d-flex align-items-center gap-2">
                {/* Desktop Logo */}
                <Link to={routes.home} className="navbar-brand m-0 p-0 position-relative turbo-logo d-none d-lg-block">
                  <img src="/assets/img/logo.png" alt="logo" width="100%" />
                </Link>

                {/* Mobile Logo (Favicon) */}
                <Link to={routes.home} className="navbar-brand m-0 position-relative turbo-logo d-lg-none">
                  <img src={Images.Favlogo} alt="favicon" width="100%" />
                </Link>

                {/* Menu Button */}
                <button
                  className="btn p-0"
                  onClick={() => setShowMenu(true)}
                  style={{ border: "none", cursor: "pointer", background: "none" }}
                >
                  <i
                    className="fi fi-br-bars-sort "
                    style={{ fontSize: "24px", color: "#e4e4e4" }}
                  ></i>




                </button>
              </div>

              {/* Coin Balance + Deposit Button */}
              {profile && (
                <div
                  className="coin-box d-flex align-items-center rounded-pill turbo-coin-box "
                  style={{
                    background: "rgba(255, 255, 255, 0.1)",
                    padding: "2px 2px 2px 12px",
                    border: "1px solid rgba(255, 255, 255, 0.05)",
                  }}
                >
                  <div
                    className="text-white fw-bold me-2"
                    style={{ fontSize: "14px", whiteSpace: "nowrap" }}
                  >
                    N$: {Number(profile?.chips).toFixed(2)}
                  </div>
                  {portalSettings?.auto_deposit === 1 && (
                    <button
                      className="btn rounded-pill px-3 py-1 fw-bold text-uppercase d-flex align-items-center justify-content-center"
                      style={{
                        background: "#22c55e",
                        border: "none",
                        height: "30px",
                        fontSize: "13px",
                        color: "#fff",
                      }}
                      onClick={handleDepositClick}
                    >
                      <span>Deposit</span>
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </nav>
      </header>

      {/* Offcanvas Menu */}
      <div
        className={`offcanvas offcanvas-start ${showMenu ? "show" : ""}`}
        tabIndex="-1"
        id="turbosportsMenu"
        style={{
          visibility: showMenu ? "visible" : "hidden",
          backgroundColor: "#000",
          width: "280px",
        }}
      >
        <div className="offcanvas-header  border-secondary d-flex justify-content-start  py-4">
          <Link to={routes.home} onClick={handleMenuClose}>
            <img src="/assets/img/logo.png" alt="logo" style={{ width: "150px" }} />
          </Link>
          <button
            type="button"
            className="btn-close btn-close-white position-absolute end-0 top-0 m-3"
            onClick={handleMenuClose}
            aria-label="Close"
          ></button>
        </div>

        <div className="offcanvas-body p-0" style={{ overflowY: "auto" }}>
          <ul className="nav flex-column sidebar-nav-custom">
            {/* Home */}
            <li className="nav-item">
              <div
                className={`nav-link d-flex align-items-center justify-content-between p-3 text-white ${location.pathname === routes.home ? "active" : ""}`}
                onClick={() => handleNavigate(routes.home)}
                style={{ cursor: "pointer" }}
              >
                <span className="menu-title text-uppercase fw-bold fs-14">Home</span>
                <i className="fi fi-sr-home fs-20"></i>
              </div>
            </li>

            {/* All Games */}
            <li className="nav-item">
              <div
                className={`nav-link d-flex align-items-center justify-content-between p-3 text-white ${location.pathname === routes.games.topGames ? "active" : ""}`}
                onClick={() => handleNavigate(routes.games.topGames)}
                style={{ cursor: "pointer" }}
              >
                <span className="menu-title text-uppercase fw-bold fs-14">All Games</span>
                <i className="fi fi-sr-dice-alt fs-20"></i>
              </div>
            </li>

            {/* Live Casino */}
            <li className="nav-item">
              <div
                className={`nav-link d-flex align-items-center justify-content-between p-3 text-white ${location.pathname === "/filtered-games" && location.search === "?type=card" ? "active" : ""}`}
                onClick={() => handleNavigate("/filtered-games?type=card")}
                style={{ cursor: "pointer" }}
              >
                <span className="menu-title text-uppercase fw-bold fs-14">Live Casino</span>
                <i className="fi fi-rr-playing-cards fs-20"></i>
              </div>
            </li>

            {/* Sports */}
            {/* <li className="nav-item  ">
              <div className="nav-link d-flex align-items-center justify-content-between p-3 text-white" onClick={handleTurboSportsClick} style={{ cursor: "pointer" }}>
                <span className="menu-title text-uppercase fw-bold fs-14 d-flex align-items-center gap-2">
                  Sports <span className="live-badge-custom">LIVE</span>
                </span>
                <i className="fi fi-rs-tennis text-white fs-20"></i>
              </div>
            </li> */}

            {/* Crash Games */}
            <li className="nav-item">
              <div
                className={`nav-link d-flex align-items-center justify-content-between p-3 text-white ${location.pathname === "/filtered-games" && location.search === "?type=crash" ? "active" : ""}`}
                onClick={() => handleNavigate("/filtered-games?type=crash")}
                style={{ cursor: "pointer" }}
              >
                <span className="menu-title text-uppercase fw-bold fs-14">Crash Games</span>
                <i className="fa-solid fa-explosion fs-20"></i>
              </div>
            </li>

            {/* Referral */}
            <li className="nav-item">
              <div
                className={`nav-link d-flex align-items-center justify-content-between p-3 text-white ${location.pathname === routes.games.bonus ? "active" : ""}`}
                onClick={() => handleNavigate(routes.games.bonus)}
                style={{ cursor: "pointer" }}
              >
                <span className="menu-title text-uppercase fw-bold fs-14">Referral</span>
                <i className="fi fi-rs-bonus-alt fs-20"></i>
              </div>
            </li>

            {/* Providers */}
            <li className="nav-item">
              <div
                className={`nav-link d-flex align-items-center justify-content-between p-3 text-white ${location.pathname === routes.games.providers ? "active" : ""}`}
                onClick={() => handleNavigate(routes.games.providers)}
                style={{ cursor: "pointer" }}
              >
                <span className="menu-title text-uppercase fw-bold fs-14">Providers</span>
                <i className="fi fi-rs-clipboard fs-20"></i>
              </div>
            </li>

            {/* How To Deposit */}
            <li className="nav-item">
              <div
                className={`nav-link d-flex align-items-center justify-content-between p-3 text-white ${location.pathname === routes.transactions.kazang_how_to_deposit ? "active" : ""}`}
                onClick={() => handleNavigate(routes.transactions.kazang_how_to_deposit)}
                style={{ cursor: "pointer" }}
              >
                <span className="menu-title text-uppercase fw-bold fs-14">How To Deposit</span>
                <i className="fi fi-rs-memo-pad fs-20"></i>
              </div>
            </li>

            {/* How to Play */}
            <li className="nav-item">
              <div
                className={`nav-link d-flex align-items-center justify-content-between p-3 text-white ${location.pathname === routes.pages.howToPlay ? "active" : ""}`}
                onClick={() => handleNavigate(routes.pages.howToPlay)}
                style={{ cursor: "pointer" }}
              >
                <span className="menu-title text-uppercase fw-bold fs-14">How to Play</span>
                <i className="fi fi-rr-interrogation fs-20"></i>
              </div>
            </li>

            {/* Terms and Conditions */}
            <li className="nav-item">
              <div
                className={`nav-link d-flex align-items-center justify-content-between p-3 text-white ${location.pathname === routes.pages.terms ? "active" : ""}`}
                onClick={() => handleNavigate(routes.pages.terms)}
                style={{ cursor: "pointer" }}
              >
                <span className="menu-title text-uppercase fw-bold fs-14">Terms and Conditions</span>
                <i className="fi fi-rs-memo-pad fs-20"></i>
              </div>
            </li>

            {/* Privacy and Policy */}
            <li className="nav-item">
              <div
                className={`nav-link d-flex align-items-center justify-content-between p-3 text-white ${location.pathname === routes.pages.privacyPolicy ? "active" : ""}`}
                onClick={() => handleNavigate(routes.pages.privacyPolicy)}
                style={{ cursor: "pointer" }}
              >
                <span className="menu-title text-uppercase fw-bold fs-14">Privacy and policy</span>
                <i className="fi fi-rs-clipboard fs-20"></i>
              </div>
            </li>
          </ul>

          <div className="p-4">
            <button
              type="button"
              className="btn w-100 text-white rounded-pill fs-15 fw-bold mb-4"
              style={{ background: "var(--primary-color)" }}
              onClick={() => handleNavigate(routes.games.topGames)}
            >
              All Games
            </button>

            <div className="d-flex justify-content-center gap-4 fs-24 text-white">
              <Link to="#" target="_blank" className="text-white">
                <i className="ri-facebook-fill"></i>
              </Link>
              <Link to="#" target="_blank" className="text-white">
                <i className="ri-instagram-line"></i>
              </Link>
              <Link to="#" target="_blank" className="text-white">
                <i className="ri-twitter-x-line"></i>
              </Link>
            </div>
          </div>
        </div>

        <style>
          {`
            .live-badge-custom {
              background: #00d283;
              color: #000;
              font-size: 10px;
              padding: 2px 6px;
              border-radius: 4px;
              font-weight: bold;
            }
            .sidebar-nav-custom .nav-item:hover {
              background: rgba(255, 255, 255, 0.05);
            }
            .sidebar-nav-custom .nav-link.active {
              background: rgba(0, 241, 129, 0.1) !important;
              border-left: 3px solid #00f181;
            }
            .sidebar-nav-custom .nav-link.active .menu-title,
            .sidebar-nav-custom .nav-link.active i {
              color: #00f181 !important;
            }

            @media (max-width: 576px) {
              .turbo-logo {
                width: 32px !important;
              }
              .turbo-coin-box {
                padding: 2px 2px 2px 10px !important;
              }
              .turbo-coin-box .text-white {
                font-size: 12px !important;
                margin-right: 6px !important;
              }
              .turbo-coin-box button {
                height: 28px !important;
                padding: 0 12px !important;
                font-size: 11px !important;
              }
              .fi-br-bars-sort {
                font-size: 20px !important;
              }
            }
          `}
        </style>
      </div>

      {/* Offcanvas Backdrop */}
      {showMenu && (
        <div
          className="offcanvas-backdrop fade show"
          onClick={handleMenuClose}
        ></div>
      )}
    </>
  );
};

export default TurboSportsHeader;
